
import { change, Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { isInteger, isValidNameWithSpace,
  renderAutoCompleteMultipleSelection,
  renderAutoCompleteSingleSelect,
  renderDateField,
  renderTextField,
  isValidAuthNumber,
} from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import { getMasterCPTByName, getPatientAuthorizationDetails, getPatientMasterData, getPatientPayerServiceCodes, savePatientAuthorization, getPatientInsuranceForAuthorizationById } from '../../actions/PatientActions';
import validate from './validate';
import SmallLoader from '../../../../img/small-loader.gif';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { showFormatedDate } from '../../../../actions/utilAction';

class AuthorizationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      StartDate: props.authData ? props.authData.StartDate : null,
      EndDate: props.authData ? props.authData.EndDate : null,
      InsuranceCompanyList: [],
      dropdownProcedureCodes: [],
      patient_insurance: [],
      patientId: props.patientId ? props.patientId : null,
      authId: props.authId ? props.authId : 0,
      // authData: props.authData,
      authProcedures: [],
      dropdownInsuranceCompany: [],
      editModal: false,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleNewRequestForMultiSelect = this.handleNewRequestForMultiSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleProcedureTypeChange = this.handleProcedureTypeChange.bind(this);
    this.getPatientPayerServiceCodes = this.getPatientPayerServiceCodes.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    // this.GetPayerServiceCode = this.GetPayerServiceCode.bind(this);
    // this.handleUpdateInput = this.handleUpdateInput.bind(this);
  }

  componentWillMount() {
    // ---------------------------------listing for Insurance company
    if (this.props.InsuranceCompanyList) {
      let list = this._updatedList(this.props.InsuranceCompanyList);
      this.setState({ InsuranceCompanyList: list });
    }
    // --------------------------
    let masterData = {
      'masterdata': 'authorizedprocedure,MASTERICD',
    };
    this.props.getPatientMasterData(masterData);
    if (this.props.authId) {
      this.props.getPatientAuthorizationDetails(this.props.authId);
    }
  }

  componentDidUpdate(prevProps,prevState){
    if (this.props.InsuranceCompanyList && prevProps.InsuranceCompanyList !== this.props.InsuranceCompanyList) {
      let list = this._updatedList(this.props.InsuranceCompanyList)
      this.setState({ InsuranceCompanyList: list || [] });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.authorizationDetails && nextProps.authorizationDetails !== this.props.authorizationDetails) {
      let patientInsuranceId = (nextProps.authorizationDetails.data && nextProps.authorizationDetails.data.patientInsuranceId) || null;
      this.getPatientPayerServiceCodes(patientInsuranceId);
    }

    if (nextProps.payerCptCodes && this.props.payerCptCodes !== nextProps.payerCptCodes) {
      let payerData = nextProps.payerCptCodes.data;
      let payerCptCodes = [];
      let payerCptCodeModifiers = [];
      if (payerData && payerData.ServiceCodes) {
        payerCptCodes = (payerData.ServiceCodes || []).map((cpt, index) => {
          return {
            'id': cpt.serviceCodeId,
            'value': cpt.serviceCode,
            ...cpt,
          };
        });
      }
      if (payerData && payerData.ServiceCodeModifiers) {
        payerCptCodeModifiers = (payerData.ServiceCodeModifiers || []).map((cptModifier, index) => {
          return {
            'id': cptModifier.modifier,
            'value': cptModifier.modifier,
            ...cptModifier,
          };
        });
      }

      let cptCodes = payerCptCodes.filter((data) => data.isRequiredAuthorization === true);
      this.setState({
        dropdownProcedureCodes: cptCodes,
        dropdownProcedureCodeModifiers: payerCptCodeModifiers,
      });
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  _updatedList(list){
    let updatePatientInsurancelist = list || [];
    if(list && list.length){
      updatePatientInsurancelist = list.map((l)=>{
        let date = showFormatedDate(moment(l.cardIssueDate).format('MM-DD-YYYY'));
        let value =  `${l.value}-${date}`;
        if(!l.cardIssueDate){
          value =  `${l.value}`;
        }

        return {
          ...l,
          value
        }
      })
    }
    return updatePatientInsurancelist;
  }
  


  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  handleEditClick = (formData) => {    
    if(formData.authorizationNumber === this.props.authorizationNumber)  {
      this.onSubmit(formData);
    }
    else {
      this.setState({
          editModal : true
      });
    
    confirmAlert({
        title: 'Edit Selected Authorization',
        message: 'You have modified the authorization number. This change will affect all claims in the billing module and appointments on the scheduler. Do you wish to proceed?',        
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              this.onSubmit(formData)
                this.setState({
                  editModal: false
                })
            }

          },
          {
            label: 'No',
            onClick: () => {
                this.setState({
                  editModal: false
                })
            }
          }
        ],
        closeOnClickOutside: false, //By Default it is true
        closeOnEscape: false,       //By Default it is true
      });
    }
  }

  onSubmit(formData) {
    let authProcedures = [];
    let formAuthProcedures = [];
    let procedures = this.props.authorizationProcedures;
    if (procedures && procedures.length) {
      // set all procedures and cpts to IsDeleted=true for updation in Arrays.
      authProcedures = procedures.map((Obj) => {
        return {
          'id': Obj.id,
          'authorizationId': Obj.authorizationId,
          'authProcedureCPT': Obj.authProcedureCPT.map((cpt) => {
            return {
              'id': cpt.id,
              'cptid': cpt.cptid,
              'authorizationProceduresId': cpt.authorizationProceduresId,
              'isDeleted': true,
              'authProcedureCPTModifiers': (cpt.authProcedureCPTModifiers || []).map((modifier) => {
                return {
                  'id': modifier.id,
                  'modifier': modifier.modifier,
                  'authProcedureCPTLinkId': modifier.authProcedureCPTLinkId,
                  'isDeleted': true,
                };
              }),
            };
          }),
          'unit': Obj.unit,
          'typeID': Obj.typeID,
          'isDeleted': true };
      });
    };
    formAuthProcedures = formData.Procedure;
    formAuthProcedures.forEach((proc) => {
      // update case for auth procedures ------
      let Procedure = authProcedures.find((Obj) => Obj.id === proc.id && Obj.isDeleted);
      if (Procedure) {
        let index = authProcedures.indexOf(Procedure);
        let authProceduresCptLinks = Procedure.authProcedureCPT;
        proc.cptid.forEach((cpt, i) => {
          let procedureCpt = authProceduresCptLinks.find((obj) => obj.cptid === cpt && obj.isDeleted);
          let cptIndex = authProceduresCptLinks.indexOf(procedureCpt);

          if (procedureCpt) {
            let authProcedureCPTModifiers = procedureCpt.authProcedureCPTModifiers || [];
            (proc.modifiers || []).forEach((cptModifier) => {
              let procedureCptModifier = authProcedureCPTModifiers.find((mobj) => mobj.modifier === cptModifier && mobj.isDeleted);
              let modifierIndex = authProcedureCPTModifiers.indexOf(procedureCptModifier);
              if (procedureCptModifier) {
                // while updating on the existing Procedure CPT code modifiers ...
                authProcedureCPTModifiers[modifierIndex] = {
                  'id': procedureCptModifier.id,
                  'modifier': procedureCptModifier.modifier,
                  'authProcedureCPTLinkId': procedureCptModifier.authProcedureCPTLinkId,
                  'isDeleted': false,
                };
              } else {
                // while adding new Procedure CPT code modifiers ...
                authProcedureCPTModifiers.push({
                  'id': 0,
                  'modifier': cptModifier,
                  'authProcedureCPTLinkId': 0,
                  'isDeleted': false,
                });
              }
            });

            // while updating on the existing Procedure CPT codes ...
            authProceduresCptLinks[cptIndex] = {
              'id': procedureCpt.id,
              'cptid': procedureCpt.cptid,
              'authorizationProceduresId': procedureCpt.authorizationProceduresId,
              'isDeleted': false,
              'authProcedureCPTModifiers': authProcedureCPTModifiers,
            };
          } else {
            let authProcedureCPTModifiers = [];
            (proc.modifiers || []).forEach((cptModifier) => {
              // while adding new Procedure CPT code modifiers ...
              authProcedureCPTModifiers.push({
                'id': 0,
                'modifier': cptModifier,
                'authProcedureCPTLinkId': 0,
                'isDeleted': false,
              });
            });

            // while adding new Procedure CPT codes ...
            authProceduresCptLinks.push({
              'id': 0,
              'cptid': cpt,
              'authorizationProceduresId': 0,
              'isDeleted': false,
              'authProcedureCPTModifiers': authProcedureCPTModifiers,
            });
          }
        });
        // while updating on the existing Authorization Procedure ...
        authProcedures[index] = {
          'id': Procedure.id,
          'authorizationId': Procedure.authorizationId,
          'authProcedureCPT': authProceduresCptLinks,
          'unit': proc.unit,
          'typeID': proc.typeid,
          'isDeleted': false,
        };
      } else {
        // while adding new on the Authorization Procedure ...
        authProcedures.push({
          'id': 0,
          'authorizationId': 0,
          'authProcedureCPT': proc.cptid.map((cpt, i) => {
            return {
              'id': 0,
              'cptid': cpt,
              'authorizationProceduresId': 0,
              'isDeleted': false,
              'AuthProcedureCPTModifiers': (proc.modifiers || []).map((modifier) => {
                return {
                  'id': 0,
                  'authProcedureCPTLinkId': 0,
                  'modifier': modifier,
                  'isDeleted': false,
                };
              }),
            };
          }),
          'unit': proc.unit,
          'typeID': proc.typeid,
          'isDeleted': false,
        });
      }
    });
    let authorizationData = {
      'id': this.state.authId,
      'patientID': this.state.patientId,
      'startDate': moment(formData.startDate).format('YYYY-MM-DD'),
      'endDate': moment(formData.endDate).format('YYYY-MM-DD'),
      'authorizationTitle': formData.authorizationTitle,
      'authorizationNumber': formData.authorizationNumber,
      'secondaryAuthorizationNumber': formData.secondaryAuthorizationNumber,
      'patientInsuranceId': formData.patientInsuranceId,
      // 'icdid1': formData.icdiD1,
      // 'icdid2': formData.icdiD2,
      // 'icdid3': formData.icdiD3,
      // 'icdid4': formData.icdiD4,
      'notes': formData.notes,
      'authorizationProcedures': authProcedures,
    };

    // console.log(JSON.stringify(authorizationData));
    this.props.savePatientAuthorization(authorizationData);
    this.setState({ open: false });
    this.props.closeDialog();
  };

  onDateChange(input, value) {
    input.onChange(moment(value).format('MM/DD/YYYY'));
    if(input.name == "startDate"){
      this.props.getPatientInsuranceForAuthorizationById(this.state.patientId,'',moment(value).format('MM-DD-YYYY'));
    }
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleNewRequestForMultiSelect(input, value, index) {
    input.onChange(value);

    if (input.name === `Procedure[${index}].cptid`) {
      if (!value || value.length !== 1) {
        this.props.dispatch(change('AuthorizationForm', `Procedure[${index}].modifiers`, null));
      }
    }


  }
  handleChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    this.getPatientPayerServiceCodes(selectedRecord.value);
  }

  handleProcedureTypeChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  getPatientPayerServiceCodes(patientInsId) {
    let patientIns = this.state.InsuranceCompanyList.find((obj) => obj.id === patientInsId);
    if (patientIns) {
      let searchObj = {
        patientId: this.state.patientId,
        payerPreference: patientIns.payerPreference,
        dateTime: moment().format('YYYY-MM-DD'),
        payerId: patientIns.insuranceCompanyId,
        patientInsuranceId: patientInsId,
      };
      this.props.getPatientPayerServiceCodes(searchObj);
    }
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }


  addRow = () => {};
  removeRow = (i) => {};

  renderMembers = ({ fields }) => {
    this.removeRow = (i, e) => {
      fields.remove(i);
    };

    this.addRow = (e) => {
      fields.push({});
    };

    return (
      <div>
        { fields.map((Procedure, index) => {

          let dropdownFilteredCodes = this.state.dropdownProcedureCodes || [];
          // let dropdownFilteredCodes = _.differenceWith(this.state.dropdownProcedureCodes, restSelectorProcedures, function(o1, o2) {
          //   return (o2['cptid'] || []).includes(o1['id']);
          // });
          let dropdownFilteredModifiers = [];
          let currentCPTArray = this.props.selectorProcedure && this.props.selectorProcedure[index] && this.props.selectorProcedure[index].cptid;
          if (currentCPTArray && currentCPTArray.length === 1) {
            let currentCPTObj = (this.state.dropdownProcedureCodes || []).find((obj) => obj.id === currentCPTArray[0]);
            dropdownFilteredModifiers = (this.state.dropdownProcedureCodeModifiers || []).filter((obj) => {
              return obj.payerServiceCodeId === (currentCPTObj && currentCPTObj.payerServiceCodeId);
            });
          }
          return (<div className="row pdr-40 parent_div" key={index}>
            <div className="col-sm-5 col-md-4 mt-35">
              <Field
                name={`Procedure[${index}].cptid`}
                label="Service Codes"
                options={dropdownFilteredCodes}
                // options={this.props.payerCptCodes}
                // handleUpdateInput={this.handleUpdateInput}
                handleNewRequest={(input, values) => this.handleNewRequestForMultiSelect(input, values, index)}
                component={renderAutoCompleteMultipleSelection}
              />
            </div>
            <div className="col-sm-3 mt-35">
              <Field
                name={`Procedure[${index}].modifiers`}
                label="Modifers"
                options={dropdownFilteredModifiers}
                // options={this.props.payerCptCodes}
                // handleUpdateInput={this.handleUpdateInput}
                handleNewRequest={this.handleNewRequestForMultiSelect}
                component={renderAutoCompleteMultipleSelection}
              />
            </div>
            <div className="col-sm-3">
              <Field
                name={`Procedure[${index}].unit`}
                type="text"
                maxLength="5"
                label="Units"
                normalize={isInteger}
                component={renderTextField}
              />
            </div>
            <div className="col-sm-5 col-md-4 mt-35">
              <Field
                name={`Procedure[${index}].typeid`}
                label="Per"
                options={this.props.masterAuthorizedProcedure}
                handleNewRequest={this.handleProcedureTypeChange}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div>
              { fields.length === index + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className="removeitem"
                      onClick={this.removeRow.bind(this, index)}
                      title="Remove Service Codes"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                  <button className="additem" title="Add Service Codes" onClick={(e) => this.addRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  <button className="removeitem"
                    onClick={this.removeRow.bind(this, index)}
                    title="Remove Service Codes"
                    type="button">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                </div>
              }
            </div>

          </div>);
        }
        )
        }
      </div>
    );
  };

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton className="mr-15 grey_btn" label="Cancel" onTouchTap={this.handleClose}/>,
      <CommonButton type="submit" primary={true} label= "Save" onTouchTap={ this.state.authId > 0 ? handleSubmit(this.handleEditClick.bind(this)) : handleSubmit(this.onSubmit.bind(this))}/>,
    ];
    return (
      <div>
        {!this.state.editModal && this.state.open ?
          <Dialog className="custom_modal_new_appointment"
            title= {this.state.authId ? 'Edit Authorization' : 'Add Authorization'}
            modal={false}
            actions={actions}
            open={this.state.open}
            autoScrollBodyContent={true}
          >
            {this.renderLoading()}
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form" noValidate>
                  <div className="row">
                    <div className="col-sm-12 require">
                      <Field
                        autoFocus={true}
                        name="authorizationTitle"
                        type="text"
                        maxLength="50"
                        normalize = {isValidNameWithSpace}
                        label="Authorization Title"
                        component={renderTextField}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-6 require">
                      <Field
                        name="authorizationNumber"
                        type="text"
                        maxLength="20"
                        normalize = {isValidAuthNumber}
                        label="Authorization Number"
                        component={renderTextField}
                      />
                      {this.state.authId > 0 ? <small className="redfont font12">Changing the authorization number will affect all claims in the billing module and appointments on the scheduler associated with the old number.</small> : null}
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <Field
                        name="secondaryAuthorizationNumber"
                        type="text"
                        maxLength="20"
                        normalize = {isValidAuthNumber}
                        label="Secondary Authorization Number"
                        component={renderTextField}
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-sm-12 col-md-6 require">
                      <Field
                        name="startDate"
                        placeholder="Start Date"
                        component={renderDateField}
                        // maxDate={new Date()}
                        openToYearSelection = {true}
                        locale="en-US"
                        selected={this.props.startDate}
                        onDateChange={this.onDateChange} />
                    </div>
                    <div className="col-sm-12 col-md-6 require">
                      <Field
                        name="endDate"
                        placeholder="End Date"
                        component={renderDateField}
                        openToYearSelection = {true}
                        minDate={new Date(this.props.startDate)}
                        locale="en-US"
                        selected={this.props.endDate}
                        onDateChange={this.onDateChange} />
                    </div>
                  </div>
                  <div className="row">
                  <div className="col-sm-12 col-md-6 require mt-35">
                      <Field
                        name="patientInsuranceId"
                        label="Insurance Company"
                        handleNewRequest={this.handleChange}
                        // options={this.state.dropdownInsuranceCompany}
                        options={this.state.InsuranceCompanyList}
                        component={renderAutoCompleteSingleSelect}
                        // onChange={this.GetPayerServiceCode}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 blackfont font12">(End date and/or number of visits must be provided)</div>
                  </div>
                  {/* <div className="row">
                    <div className="col-sm-3 mt-35">
                      <Field
                        name="icdiD1"
                        label="Primary Diagnosis"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterICD}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-3 mt-35">
                      <Field
                        name="icdiD2"
                        label="Diagnosis 2"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterICD}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-3 mt-35">
                      <Field
                        name="icdiD3"
                        label="Diagnosis 3"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterICD}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                    <div className="col-sm-3 mt-35">
                      <Field
                        name="icdiD4"
                        label="Diagnosis 4"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterICD}
                        component={renderAutoCompleteSingleSelect} />
                    </div>
                  </div> */}
                  <div className="row">                    
                    <div className="col-sm-12">
                      <Field
                        name="notes"
                        type="text"
                        maxLength="1000"
                        label="Notes"                        
                        // normalize = {isValidNameWithSpace}
                        component={renderTextField}
                      />
                      <small className="blackfont font12">{this.props.notes && this.props.notes.length ? `${1000 - this.props.notes.length} characters remaining` : '1000 characters remaining'}</small>
                    </div>
                  </div>
                  <FieldArray name="Procedure" component={this.renderMembers} />
                </form>
              </div>
            </div>
          </Dialog> : null }
      </div>
    );
  };
}
const selector = formValueSelector('AuthorizationForm');
AuthorizationModal = reduxForm({
  form: 'AuthorizationForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(AuthorizationModal);

function mapStateToProps(state, ownProps) {
  let masterAuthorizedProcedure = [], masterICD = [], initialData = {
    Procedure: [{}],
  };
  let authorizationProcedures = [];
  if (ownProps.authId && state.patient.authorizationDetails) {
    let authorization = state.patient.authorizationDetails.data;
    authorizationProcedures = (state.patient.authorizationDetails.data && state.patient.authorizationDetails.data.authorizationProcedures) || [];
    let Procedure = authorizationProcedures.map((obj) => {
      let authprocedurecptModifiers = [];
      if ((obj.authProcedureCPT || []).length === 1) {
        let authCpt = obj.authProcedureCPT[0];
        authprocedurecptModifiers = (authCpt.authProcedureCPTModifiers || []).map((obj) => obj.modifier);
      }
      return {
        'authorizationId': obj.authorizationId,
        'id': obj.id,
        'isdeleted': obj.isdeleted,
        'typeid': obj.typeID,
        'unit': obj.unit,
        'cptid': (obj.authProcedureCPT || []).map((cptObj) => cptObj.cptid),
        'modifiers': authprocedurecptModifiers,
      };
    });
    initialData = {
      ...authorization,
      'Procedure': (Procedure && Procedure.length) ? Procedure : [{}],
    };
  }
  if (state.patient.patientMasterData) {
    masterAuthorizedProcedure = state.patient.patientMasterData.masterAuthorizedProcedure || [];
    masterICD = state.patient.patientMasterData.masterICD || [];
  }
  return {
    loading: state.patient.loading || state.patient.loadingMasterData,
    masterAuthorizedProcedure: masterAuthorizedProcedure,
    masterICD: masterICD,
    initialValues: initialData,
    payerCptCodes: state.patient.payerCptCodes,
    authorizationProcedures: authorizationProcedures,
    authorizationDetails: state.patient.authorizationDetails,
    selectorProcedure: selector(state, 'Procedure'),
    notes: selector(state, 'notes'),
    startDate: selector(state, 'startDate'),
    endDate: selector(state, 'endDate'),
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    authorizationNumber: initialData.authorizationNumber
  };
};

export default connect(mapStateToProps, { getMasterCPTByName, getPatientMasterData, savePatientAuthorization, getPatientAuthorizationDetails, getPatientPayerServiceCodes, getPatientInsuranceForAuthorizationById })(AuthorizationModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/authorization/authorization_modal.js